// extracted by mini-css-extract-plugin
export var button = "_os-0";